var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img && !!_vm.img.URL)?_c('v-avatar',{attrs:{"size":_vm.customWidth,"tile":""}},[_c('v-img',{attrs:{"src":_vm.img.URL,"contain":""}})],1):_c('Avatar',{attrs:{"username":_vm.name,"size":_vm.customWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }